import { render, staticRenderFns } from "./TouchPayCell.vue?vue&type=template&id=473f94cc&scoped=true"
import script from "./TouchPayCell.vue?vue&type=script&lang=ts"
export * from "./TouchPayCell.vue?vue&type=script&lang=ts"
import style0 from "./TouchPayCell.vue?vue&type=style&index=0&id=473f94cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f94cc",
  null
  
)

export default component.exports